/**
 * DTOs de operadores de la consola de plataforma (`/operators/*`). Ver docs/FASE-0.md §5
 * "Operadores" y §3 `operators`.
 */
import { z } from "zod";
import { NewPasswordSchema } from "./accounts.js";
export const OperatorLoginInputSchema = z.object({
    email: z.email(),
    password: z.string().min(1).max(200),
    /** Requerido cuando el operador ya activó TOTP (`operators.totp_secret_encrypted` no nulo). */
    totp: z
        .string()
        .regex(/^\d{6}$/)
        .optional(),
});
export const OperatorRoleSchema = z.enum(["owner", "support", "billing"]);
/** Sin valores explícitos en FASE-0 §3; `active`/`suspended` es la decisión mínima razonable (igual que `packages/db`). */
export const OperatorStatusSchema = z.enum(["active", "suspended"]);
export const OperatorSchema = z.object({
    id: z.uuid(),
    email: z.email(),
    fullName: z.string(),
    role: OperatorRoleSchema,
    status: OperatorStatusSchema,
    totpEnabled: z.boolean(),
    lastLoginAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
/** Respuesta de `POST /operators/totp/setup`: URI para el autenticador (secreto ya cifrado en BD). */
export const OperatorTotpSetupResponseSchema = z.object({
    otpauthUrl: z.string(),
});
export const OperatorTotpVerifyInputSchema = z.object({
    code: z.string().regex(/^\d{6}$/),
});
/**
 * Respuesta de `POST /operators/login` y `POST /operators/refresh` (docs/FASE-1.md §5): a
 * diferencia de `TokenResponseSchema` (claims.ts, usuarios/módulos), el refresh de operador es
 * siempre obligatorio (rotación forzosa) y la respuesta incluye el propio operador para que la
 * consola no necesite una segunda llamada a `GET /operators/me` tras iniciar sesión.
 */
export const OperatorLoginResponseSchema = z.object({
    access_token: z.string(),
    token_type: z.literal("Bearer"),
    expires_in: z.number().int().positive(),
    refresh_token: z.string(),
    operator: OperatorSchema,
});
/** `POST /operators/refresh` y `POST /operators/logout`: el refresh token opaco (`crt_op_...`). */
export const OperatorRefreshInputSchema = z.object({
    refresh_token: z.string().min(1),
});
/** `POST /operators/forgot`: siempre responde 202 exista o no la cuenta (no revela cuál es el caso). */
export const OperatorForgotPasswordInputSchema = z.object({
    email: z.email(),
});
/** `POST /operators/reset`: token opaco recibido por correo (`opr_...`) y la contraseña nueva. */
export const OperatorResetPasswordInputSchema = z.object({
    token: z.string().min(1),
    password: NewPasswordSchema,
});
//# sourceMappingURL=operators.js.map